export const white = "#ffffff";
export const primaryText = "#333333";
export const secondaryText = "#9e9e9e";
export const ternaryText = "#666666";

export const primary = "#2f93e0";
export const primaryDarkest = "#0F2535";
export const primaryDark = "#0A67B1";
export const primaryLight = "#74c0fb";

export const secondaryDark = "#053B62";

export const hover = "rgba(153, 153, 153, 0.08)";
export const divider = "#cccccc";
export const disabledBackground = "rgba(153, 153, 153, 0.7)";
export const secondaryBackground = "#e0e0e0";

export const info = "#0A67B1" ;
export const success = "#48B350";
export const danger = "#db4437";
export const alert = "#fb8c00";
export const disable = "#fbe1e9";

export const dangerHighlight = "#f8e8e6";

export const shadow40 = "rgba(0, 0, 0, 0.4)";
export const shadow60 = "rgba(0, 0, 0, 0.6)";

export const theme = {}; //empty on purpose


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/colors.ts